var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 812,
    viewBox: "0 0 375 812",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_1041",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 375,
    height: 812
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 812,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_1041)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_2_1041)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 196.5,
    ry: 181,
    transform: "matrix(-1 0 0 1 505.5 676)",
    fill: "url(#paint0_angular_2_1041)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter1_f_2_1041)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -12.5,
    cy: 830.971,
    rx: 94.5,
    ry: 86.9714,
    fill: "url(#paint1_angular_2_1041)",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter2_f_2_1041)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.5,
    cy: 86.9714,
    rx: 94.5,
    ry: 86.9714,
    fill: "url(#paint2_angular_2_1041)",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter3_f_2_1041)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.5,
    cy: 29.5,
    rx: 113.5,
    ry: 104.5,
    fill: "url(#paint3_angular_2_1041)",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2_1041",
    x: 209,
    y: 395,
    width: 593,
    height: 562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_2_1041"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2_1041",
    x: -207,
    y: 644,
    width: 389,
    height: 373.943,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_2_1041"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_2_1041",
    x: -154,
    y: -100,
    width: 389,
    height: 373.943,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_2_1041"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2_1041",
    x: 98,
    y: -175,
    width: 427,
    height: 409,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    result: "effect1_foregroundBlur_2_1041"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_2_1041",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(196.5 181) rotate(90) scale(252.457 274.076)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266645,
    stopColor: "#ECACAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.572917,
    stopColor: "#9895EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#90A2F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C55492"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_angular_2_1041",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-12.5 830.971) rotate(90) scale(121.307 131.808)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9CBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266645,
    stopColor: "#ECACAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3125,
    stopColor: "#9895EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#C55492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8125,
    stopColor: "#90A2F8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_angular_2_1041",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.5 86.9714) rotate(90) scale(152.102 165.268)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.791667,
    stopColor: "#9895EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9999,
    stopColor: "#ECACAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C55492"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_angular_2_1041",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(311.5 29.5) rotate(90) scale(182.757 198.497)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9DAFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#9895EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0002,
    stopColor: "#C55492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266645,
    stopColor: "#ECACAD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.fcb891d49e0a61bc181f1a179063722e.svg";
export { ForwardRef as ReactComponent };